import React from 'react';
import CGamePage from './CGamePage';
import WordSearchPage from './WordSearchPage';

const CWordSearch = () => (
  <CGamePage gameKey="wordSearch" title="Word Search" page={WordSearchPage} />
);

export default CWordSearch;
